import { connect } from 'react-redux'

import GuestMenu from './guestMenu'
import { closeModal, openModal } from '../../../../../common/actions/layout'
import { getUserProfile } from '../../../../../common/actions/user'
import { getSessionSuccessAction } from '../../../../../common/actions/user/session'

const mapStateToProps = (state) => {
  const {
    common: {
      currentSite
    }
  } = state

  return {
    currentSite
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(closeModal()),
    openModal: (data) => dispatch(openModal(data)),
    handleSignInSuccess: token => {
      dispatch(getSessionSuccessAction(token))
      return dispatch(getUserProfile(token))
    }
  }
}

const guestMenuContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GuestMenu)

export default guestMenuContainer



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/user/guestMenuContainer.js